module.exports = __webpack_public_path__ + "img/w3_circle_grid_black.3a45e48c.png";